import { Grid, GridItem, GridProps } from "@chakra-ui/react";
import React, { PropsWithChildren } from "react";

type InlineItemProps = PropsWithChildren<{
  title: React.ReactNode;
}> | GridProps;

const InlineItem: React.FC<InlineItemProps> = ({ title, children, ...props }) => {
  return (
    <Grid
      templateColumns="repeat(3, 1fr)"
      {...props}
    >
      <GridItem colSpan={1}>
        <legend className=" text-dark-100">{title}</legend>
      </GridItem>
      <GridItem colSpan={2}>
        {children}
      </GridItem>
    </Grid>
  );
};

export default React.memo(InlineItem);
